module.exports = __webpack_public_path__ + "static/step1-9401989a22b7409d7bbb27e828a94d21.png";